import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import Image from 'next/image';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Button } from '@/components/buttons';
import { ContentContainer } from '@/components/layout';
import { Text } from '@/components/typography';
import React from 'react';
const SeoImage = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["aboutUs"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("ceo.imageAlt");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Image src="/images/sections/aboutUs/ceo.png" alt={t1} width={568} height={504} className="md:max-w-fullg mx-auto max-w-[90%]" />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export function Ceo() {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["aboutUs"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="hidden w-full shrink lg:block"><SeoImage /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("ceo.title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <SectionHeadline className="mb-4 px-0 lg:text-left" anchorKey="ceo.title">{t2}</SectionHeadline>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("ceo.text");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <Text variant="p2" className="mb-2 text-center text-gray-800 lg:text-left">{t4}</Text>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="my-12 lg:hidden"><SeoImage /></div>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("ceo.cta");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <Button to="https://www.linkedin.com/in/richard-kotrl%C3%ADk-45126630/" testId="pricingDeferredPayment" analyticsParam="pricingDeferredPayment" size="lg" variant="secondary" className="mx-auto mt-10 lg:mx-0">{t7}</Button>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t5 || $[17] !== t8) {
    t9 = <ContentContainer><div className="flex flex-col items-center gap-12 px-4 lg:flex-row lg:gap-10">{t1}<div className="w-[29.25rem] max-w-full shrink-0">{t3}{t5}{t6}{t8}</div></div></ContentContainer>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}